import { requestService as api } from "../Request.service";

const API_URL = {
  API_LOG: `/ERP/product-order/log.php`,
  API_MANAGE: `/ERP/product-order/manage.php`,
  API_PREVIEW: `/ERP/product-order/preview.php`,
  API_SEARCH: `/ERP/product-order/search.php`,
  API_GET: `/ERP/product-order/get.php`,
  API_REQUISITION: `/ERP/product-order/requisition.php`,
  API_WORK_ORDER: `/ERP/product-order/work-order.php`,
  API_TRIM_ROOM: `/ERP/product-order/trim-room.php`,
  API_CURING_ROOM: `/ERP/product-order/curing-room.php`,
};

const ProductionOrderService = () => {
  const preview = (parm = {}, config = {}) =>
    api.post(`${API_URL.API_PREVIEW}`, parm, { ...config, cancle: true });
  const search = (parm = {}, config = {}) =>
    api.post(`${API_URL.API_SEARCH}`, parm, { ...config, cancle: true });
  const logAction = (parm = {}, config = {}) =>
    api.post(`${API_URL.API_LOG}`, parm, { ...config, cancle: true, ignoreLoading: true });
  const manage = (parm = {}, config = {}) =>
    api.post(`${API_URL.API_MANAGE}`, parm, { ...config, cancle: true });
  const get = (pdcode, config = {}) =>
    api.post(`${API_URL.API_GET}`, { pdcode }, { ...config, cancle: true });
  /* ใบขอเบิกเพื่อเตรียมการผลิตประจำวัน */
  const requisition = (pdcode, config = {}) =>
    api.post(`${API_URL.API_REQUISITION}`, { pdcode }, { ...config, cancle: true });

  /* ใบสั่งงานการผลิต */
  const workOrder = (pdcode, config = {}) =>
    api.post(`${API_URL.API_WORK_ORDER}`, { pdcode }, { ...config, cancle: true });

  /* ใบขอเบิกห้องตัดแต่ง */
  const trimRoom = (pdcode, config = {}) =>
    api.post(`${API_URL.API_TRIM_ROOM}`, { pdcode }, { ...config, cancle: true });

  /* รายงานการเตรียมการและผสม (ห้องเคี่ยว) */
  const curingRoom = (pdcode, config = {}) =>
    api.post(`${API_URL.API_CURING_ROOM}`, { pdcode }, { ...config, cancle: true });

  return {
    logAction,
    manage,
    preview,
    search,
    get,
    requisition,
    workOrder,
    trimRoom,
    curingRoom,
  };
};

export default ProductionOrderService;